<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> {{ header }} </div>
        <div class="modal-body">
            <div class="msg-wrapper">{{ msg }}</div>
            <div class="list-wrapper">
                <div class="list" *ngFor="let item of list" [innerHTML]="item"></div>
            </div>
            
            <div *ngIf="!hideQualification" class="qualification-wrapper">
                <label>Vous pouvez qualifier cette identité en sélectionnant le type de document du patient que vous avez vérifié pour vous assurer de son identité :</label>
                <div class="select-container">
                    <ng-select
                        [items]="documents"
                        bindLabel="label"
                        bindValue="value"
                        [(ngModel)]="selectedDocument"
                        [clearable]="false"
                        [searchable]="false"
                        appendTo="body"
                        placeholder="Sélectionnez un document">
                    </ng-select>
                </div>
            </div>

            <div class="button-wrapper">
                <frg-button (activated)="confirmAction()">Valider</frg-button>
                <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>
